import { createChat } from '@n8n/chat';

function createN8nChat() {
  if (!document.getElementById('n8n-chat')) return;

  createChat({
    webhookUrl: 'https://workshops-de.app.n8n.cloud/webhook/9f13766e-0142-49ff-abd8-7c65189178e5/chat',
    defaultLanguage: 'de',
    showWelcomeScreen: false,
    initialMessages: [],
    enableStreaming: false,
    target: document.getElementById('n8n-chat'),
    i18n: {
      en: {
        title: 'Hi there! 👋',
        subtitle: "Start a chat. We're here to help you 24/7.",
        footer: '',
        getStarted: 'New Conversation',
        inputPlaceholder: 'Type your question..',
      },
      de: {
        title: 'Hallo! 👋',
        subtitle: "Starte eine Chat-Sitzung. Wir sind 24/7 für dich da.",
        footer: '',
        getStarted: 'Neue Sitzung',
        inputPlaceholder: 'Stelle deine Frage..',
      }
    }
  });
}

document.addEventListener("turbo:load", createN8nChat);